import InventoryAwareStorePickerModal from 'components/GlobalModals/InventoryAwareStorePickerModal/InventoryAwareStorePickerModal';
import { withInventoryAwareStorePickerModalProps } from 'components/GlobalModals/InventoryAwareStorePickerModal/withInventoryAwareStorePickerModalProps';

export default withInventoryAwareStorePickerModalProps(InventoryAwareStorePickerModal);
